import { ABOUT_STORY, ABOUT_TIMELINE, BUSINESS } from "#/lib/constants";
import { SectionLabel } from "#/components/shared/SectionLabel";
import { useScrollAnimation } from "#/hooks/useScrollAnimation";

/**
 * Our story + timeline. Two columns on desktop: the narrative on the left,
 * the timeline as a flame-ruled rail on the right.
 */
export function AboutStory() {
  const { ref, isVisible } = useScrollAnimation(0.05);

  return (
    <section className="bg-white py-20 lg:py-28">
      <div ref={ref} className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-12 lg:gap-16">
          {/* Narrative */}
          <div className="lg:col-span-7">
            <SectionLabel>How We Got Here</SectionLabel>
            <h2
              className={`mt-4 font-heading text-3xl font-extrabold leading-[1.1] text-graphite transition-all duration-700 sm:text-4xl lg:text-5xl ${
                isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
              }`}
            >
              Concrete came second.
            </h2>
            <div className="mt-8 space-y-5">
              {ABOUT_STORY.map((p) => (
                <p key={p.slice(0, 24)} className="leading-relaxed text-concrete-dark">
                  {p}
                </p>
              ))}
            </div>
          </div>

          {/* Timeline */}
          <ol className="mt-14 lg:col-span-5 lg:mt-0">
            {ABOUT_TIMELINE.map((t, i) => (
              <li
                key={t.year}
                className={`relative border-l-2 border-gray-200 pb-9 pl-8 last:pb-0 transition-all duration-500 ${
                  isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"
                }`}
                style={{ transitionDelay: isVisible ? `${i * 90}ms` : "0ms" }}
              >
                <span
                  aria-hidden="true"
                  className="absolute -left-[9px] top-1 block h-4 w-4 rounded-full bg-flame ring-4 ring-white"
                />
                <p className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-flame">
                  {t.year}
                </p>
                <p className="mt-2 font-heading text-xl font-bold text-graphite">
                  {t.title}
                </p>
                <p className="mt-1 leading-relaxed text-concrete-dark">{t.detail}</p>
              </li>
            ))}
          </ol>
        </div>

        <p className="mt-14 border-t border-gray-200 pt-8 text-sm text-concrete-dark">
          Blue Rock Concrete is the sister company of{" "}
          <a
            href={BUSINESS.sisterUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-graphite underline decoration-flame decoration-2 underline-offset-4 hover:text-flame"
          >
            {BUSINESS.sisterCompany}
          </a>
          , same family, same crews, same standard.
        </p>
      </div>
    </section>
  );
}
